module.exports = __webpack_public_path__ + "img/he.7daf1610.png";